import React, { Fragment, Component } from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import Dialog from '../../components/IdentifiedDialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import withMobileDialog from '@material-ui/core/withMobileDialog'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import { CpfField } from '../../components/Fields'
import { connect } from 'react-redux'
import { authorsActions, messageActions } from '../../actions'
import { withStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'
import AuthorAvatar from '../../components/AuthorAvatar'
import IconButton from '@material-ui/core/IconButton'
import DeleteIcon from '@material-ui/icons/Delete'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { readOnly } from '../../utils/permissions'

const styles = theme => ({
  box: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    margin: 'auto',
    width: '80%',
    maxWidth: '400px',
    background: 'blue'
  }),
  labelImage: {
    display: 'flex',
    justifyContent: 'center',
    width: 140,
    margin: '10px auto',
    borderRadius: '50%'
  },
  errorMessage: {
    position: 'absolute',
    bottom: '-22px',
    left: 0
  },
  wrapperLoader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '280px',
    width: '100%',
    height: '100%',
    minHeight: '200px'
  },
  formGroup: {
    padding: '12px 0'
  },
  root: {
    display: 'flex',
    minHeight: '100%',
    padding: '16px 0',
    boxSizing: 'border-box',
    flexDirection: 'column',
    background: '#fafafa'
  },
  formControl: {
    margin: '14px 0'
  },
  wrapperImage: {
    position: 'relative',
    width: 200,
    margin: 'auto'
  },
  removeImageButton: {
    position: 'absolute',
    top: 0,
    zIndex: 3,
    right: 30,
    width: 35,
    height: 35,
    background: '#eee',
    '&:hover, &:focus': {
      background: '#ddd'
    },
    '& svg': {
      fontSize: 19
    }
  },
  showOnPWA: {
    marginTop: -15,
    marginBottom: 10
  }
})

class EditModal extends Component {
  handleSave = author => {
    const { onClose, addAuthor, editAuthor, changeMessage } = this.props
    if (author._id) {
      editAuthor(author).then(res => {
        changeMessage({ message: 'Alteração realizada com sucesso.' })
        onClose()
      })
    } else {
      addAuthor(author).then(res => {
        changeMessage({ message: 'Cadastro realizado com sucesso.' })
        onClose()
      })
    }
  }
  handleSubmit = (e, author) => {
    e.preventDefault()
    const { setAuthorFormTouched } = this.props

    if (this.props.authorFormErrors.valid) {
      this.handleSave(author)
    } else {
      setAuthorFormTouched()
    }
    return false
  }
  handleChangeFile = e => {
    e.preventDefault()
    const { handleChangeAuthor, author } = this.props

    let reader = new FileReader()
    let [file] = e.target.files

    if (file) {
      reader.onloadend = () => {
        handleChangeAuthor({
          ...author,
          avatarFile: file || '',
          imagePreviewUrl: reader.result || '',
          exibirFotoPwa: true
        })
      }

      reader.readAsDataURL(file)
    } else {
      handleChangeAuthor({
        ...author,
        avatarFile: file || '',
        imagePreviewUrl: reader.result || ''
      })
    }
  }
  clearErrors = () => {
    this.setState({ formErrors: {} })
  }
  removeImage = () => {
    const { handleChangeAuthor, author } = this.props
    handleChangeAuthor({
      ...author,
      avatarFile: '',
      foto: '',
      imagePreviewUrl: ''
    })
  }
  render() {
    const {
      fullScreen,
      onClose,
      open = false,
      classes,
      author,
      handleChangeAuthor,
      loadingAuthor,
      authorFormErrors,
      formTouched,
      token
    } = this.props

    const { handleSubmit, clearErrors, handleChangeFile } = this

    const isReadOnly = readOnly('autores', token)

    return (
      <div>
        <Dialog
          modalId={author._id ? 'autores-editar' : 'autores-novo'}
          modalParams={{ registro: author._id }}
          fullScreen={fullScreen}
          fullWidth
          open={open}
          onClose={onClose}
          className={classes.dialog}
        >
          {loadingAuthor ? (
            <div className={classes.wrapperLoader}>
              <CircularProgress />
            </div>
          ) : (
            <Fragment>
              <DialogTitle id={(author._id ? 'autores-editar' : 'autores-novo') + '-title'}>
                {isReadOnly ? (
                  'Autor'
                ) : (
                  <Fragment>{author._id ? 'Editar autor' : 'Cadastrar autor'}</Fragment>
                )}
              </DialogTitle>
              <DialogContent>
                <form
                  id={'author-form'}
                  noValidate
                  onSubmit={e => {
                    handleSubmit(e, author)
                  }}
                >
                  <div className={classes.wrapperImage}>
                    {!!(author.imagePreviewUrl || author.foto) && (
                      <IconButton
                        className={classes.removeImageButton}
                        onClick={this.removeImage}
                        aria-label="Remove imagem"
                      >
                        <DeleteIcon />
                      </IconButton>
                    )}
                    <label
                      htmlFor="avatar-image"
                      className={classes.labelImage}
                      style={{ cursor: 'pointer' }}
                    >
                      <AuthorAvatar
                        name={author.nome}
                        src={author.imagePreviewUrl || author.foto}
                        readOnly={isReadOnly}
                      />
                    </label>
                    <FormControlLabel
                      className={classes.showOnPWA}
                      control={
                        <Checkbox
                          checked={
                            !author.imagePreviewUrl && !author.foto ? false : !!author.exibirFotoPwa
                          }
                          onChange={e => {
                            clearErrors()
                            handleChangeAuthor({
                              ...author,
                              exibirFotoPwa: !author.exibirFotoPwa
                            })
                          }}
                          disabled={(!author.imagePreviewUrl && !author.foto) || isReadOnly}
                          value={'exibirFotoPwa'}
                          color="primary"
                        />
                      }
                      label={'Exibir imagem no PWA'}
                    />
                  </div>
                  <input
                    id="avatar-image"
                    type={'file'}
                    onChange={handleChangeFile}
                    style={{ display: 'none' }}
                    disabled={isReadOnly}
                  />
                  <FormControl
                    error={!((authorFormErrors.fields || {})['nome'] || {}).valid && formTouched}
                    className={classes.formControl}
                    fullWidth
                  >
                    <InputLabel htmlFor="field-nome">Nome completo</InputLabel>
                    <Input
                      disabled={isReadOnly}
                      fullWidth
                      required={'required'}
                      type="text"
                      onChange={e => {
                        clearErrors()
                        handleChangeAuthor({
                          ...author,
                          nome: e.target.value
                        })
                      }}
                      value={author.nome}
                      autoFocus
                      id="field-nome"
                    />
                    {!((authorFormErrors.fields || {})['nome'] || {}).valid && formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((authorFormErrors.fields || {})['nome'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>
                  <FormControl
                    error={
                      !((authorFormErrors.fields || {})['documento'] || {}).valid && formTouched
                    }
                    className={classes.formControl}
                    fullWidth
                  >
                    <InputLabel htmlFor="field-documento">CPF</InputLabel>
                    <Input
                      disabled={isReadOnly}
                      fullWidth
                      required={'required'}
                      type="text"
                      inputComponent={CpfField}
                      onChange={e => {
                        clearErrors()
                        handleChangeAuthor({
                          ...author,
                          documento: e.target.value
                        })
                      }}
                      value={author.documento || ''}
                      id="field-documento"
                    />
                    {!((authorFormErrors.fields || {})['documento'] || {}).valid && formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((authorFormErrors.fields || {})['documento'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>
                  <FormControl
                    error={!((authorFormErrors.fields || {})['email'] || {}).valid && formTouched}
                    className={classes.formControl}
                    fullWidth
                  >
                    <InputLabel htmlFor="field-email">E-mail</InputLabel>
                    <Input
                      disabled={isReadOnly}
                      fullWidth
                      required={'required'}
                      type="text"
                      onChange={e => {
                        clearErrors()
                        handleChangeAuthor({
                          ...author,
                          email: e.target.value
                        })
                      }}
                      value={author.email}
                      id="field-email"
                    />
                    {!((authorFormErrors.fields || {})['email'] || {}).valid && formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((authorFormErrors.fields || {})['email'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>
                  <FormControl
                    error={
                      !((authorFormErrors.fields || {})['especializacao'] || {}).valid &&
                      formTouched
                    }
                    className={classes.formControl}
                    fullWidth
                  >
                    <InputLabel htmlFor="field-especializacao">Especialização</InputLabel>
                    <Input
                      disabled={isReadOnly}
                      fullWidth
                      required={'required'}
                      type="text"
                      onChange={e => {
                        clearErrors()
                        handleChangeAuthor({
                          ...author,
                          especializacao: e.target.value
                        })
                      }}
                      value={author.especializacao}
                      id="field-especializacao"
                    />
                    {!((authorFormErrors.fields || {})['especializacao'] || {}).valid &&
                    formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((authorFormErrors.fields || {})['especializacao'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>

                  <FormControl
                    error={
                      !((authorFormErrors.fields || {})['curriculo'] || {}).valid && formTouched
                    }
                    className={classes.formControl}
                    fullWidth
                  >
                    <InputLabel htmlFor="field-curriculo">Currículo</InputLabel>
                    <Input
                      disabled={isReadOnly}
                      fullWidth
                      required={'required'}
                      multiline
                      type="text"
                      onChange={e => {
                        clearErrors()
                        handleChangeAuthor({
                          ...author,
                          curriculo: e.target.value
                        })
                      }}
                      value={author.curriculo}
                      id="field-curriculo"
                    />
                    {!((authorFormErrors.fields || {})['curriculo'] || {}).valid && formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((authorFormErrors.fields || {})['curriculo'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>
                </form>
              </DialogContent>
              <DialogActions>
                <Button onClick={onClose} color="default">
                  {isReadOnly ? 'Voltar' : 'Cancelar'}
                </Button>
                {!isReadOnly && (
                  <Button type={'submit'} form={'author-form'} color="primary" variant="raised">
                    Salvar
                  </Button>
                )}
              </DialogActions>
            </Fragment>
          )}
        </Dialog>
      </div>
    )
  }
}

EditModal.propTypes = {
  fullScreen: PropTypes.bool.isRequired
}

const mapStateToProps = state => {
  return {
    author: state.authors.author,
    loadingAuthor: state.authors.loadingAuthor,
    authorFormErrors: state.authors.authorFormErrors,
    formTouched: state.authors.authorFormTouched,
    token: state.auth.token
  }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(authorsActions.openModal())
    },
    closeModal: () => {
      dispatch(authorsActions.closeModal())
    },
    handleChangeAuthor: author => {
      dispatch(authorsActions.handleChangeAuthor(author))
    },
    addAuthor: author => {
      return dispatch(authorsActions.addAuthor(author))
    },
    editAuthor: author => {
      return dispatch(authorsActions.editAuthor(author))
    },
    setAuthorFormTouched: author => {
      dispatch(authorsActions.setAuthorFormTouched())
    },
    changeMessage: ({ message }) => {
      dispatch(messageActions.changeMessage({ message }))
    },
    fetchAuthors: ({ page, perPage }) => {
      dispatch(authorsActions.fetchAuthors({ page, perPage }))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMobileDialog()(withStyles(styles)(EditModal)))



// WEBPACK FOOTER //
// ./src/containers/Authors/EditModal.js